<template>
    <div class="input-textarea">
        <textarea ref="input" name="WalletAddress" autocomplete="off" :value="modelValue" :maxlength="maxLength"
            @input="onInput" placeholder="" @blur="onBlur"></textarea>
        <div v-if="masked" class="mask text-center flex justify-center items-center"
            @click="clickInput()">
            Enter Wallet Address Here
        </div>
    </div>
</template>
<script>
import Utility from '@/helper/Utility';
export default {
    name: "InputTextarea",
    props: {
        modelValue: {
            type: String,
            default: "",
        },
        maxLength: {
            type: Number,
            default: 100,
        },
    },
    components: {},
    mixins: [],
    emits: ["update:modelValue"],
    data: function () {
        return {
            masked: true,
            input: "",
        };
    },
    computed: {},
    watch: {
        modelValue: function () {
            this.onBlur()
        }
    },
    methods: {
        onInput: function (e) {
            let val = e.target.value;
            this.$emit("update:modelValue", val);
        },
        onBlur: function(){
            if (!Utility.isEmptyStr(this.modelValue)) {
                this.hideMask()
            } else {
                this.showMask()
            }
        },
        clickInput: function(){
            this.hideMask()
            this.$nextTick(() => {
                if(this.$refs.input != null){
                    this.$refs.input.focus()
                }
            })
        },
        showMask: function () {
            this.masked = true
        },
        hideMask: function () {
            // console.log("on blur")
            this.masked = false
        }
    },
};
</script>

<style lang="scss" scoped>
.input-textarea {
    position: relative;
    line-height: 0;

    div.mask {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }

    textarea {
        border-radius: 15px;
        border: solid 1px #aaa;
        background-color: #fff;
        width: 100%;
        padding: 16px 16px 12px;
        min-height: 80px;
        overflow: hidden;
        text-align: center;
        resize: none;
        outline: none;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        line-height: normal;
    }
}
</style>
